import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getBookingsReset } from '@pages/booking/store';
import { useBookingRangeContext } from '@pages/booking/contexts/BookingRangeContext';
import { FUTURE_WEEK_COUNT, PAST_WEEK_COUNT } from '@pages/booking/constants';

export const BookingCalendarToolbarDateRange = () => {
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const { range, setRange, weekRanges } = useBookingRangeContext();

    const handleChangeDateRange = (diff: 1 | -1) => () => {
        dispatch(getBookingsReset());
        setRange((prevRange) => {
            const newRange = weekRanges.rangesByOffset[prevRange.offset + diff];
            return newRange ? newRange : prevRange;
        });
    };

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                <IconButton disabled={range.offset <= -PAST_WEEK_COUNT} onClick={handleChangeDateRange(-1)}>
                    <ChevronLeftIcon />
                </IconButton>
                <IconButton disabled={range.offset >= FUTURE_WEEK_COUNT} onClick={handleChangeDateRange(1)}>
                    <ChevronRightIcon />
                </IconButton>
            </Box>
            <Box sx={{ fontSize: '1rem' }}>
                {`${new Intl.DateTimeFormat(i18n.language, {
                    day: 'numeric',
                    month: range.startDate.getMonth() !== range.endDate.getMonth() ? 'long' : undefined,
                    year: range.startDate.getFullYear() !== range.endDate.getFullYear() ? 'numeric' : undefined,
                }).format(range.startDate)} — ${new Intl.DateTimeFormat(i18n.language, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                }).format(range.endDate)}`}
            </Box>
        </Box>
    );
};

export default BookingCalendarToolbarDateRange;
